{
  "cityMap": {
    "products": {
      "paper": {
        "productId": 3511,
        "variations": {
          "small-no-frame": 10759,
          "medium-no-frame": 10761,
          "large-no-frame": 10763,
          "small-black": 10760,
          "medium-black": 10762,
          "large-black": 10764,
          "small-oak": 27760,
          "medium-oak": 27761,
          "large-oak": 27762,
          "extra-large-no-frame": 53640,
          "small-white": 53641,
          "medium-white": 53642,
          "large-white": 53643
        }
      },
      "acryl": {
        "productId": 46918,
        "variations": { "xs": 46921, "small": 46922, "medium": 57101 }
      },
      "aluminium": {
        "productId": 46914,
        "variations": { "xs": 46915, "small": 46916, "medium": 46917 }
      },
      "tegel": { "productId": 66571, "variations": {} }
    }
  },
  "housewarming": {
    "products": {
      "paper": {
        "productId": 4600,
        "variations": {
          "small-no-frame": 11013,
          "medium-no-frame": 11015,
          "large-no-frame": 11017,
          "small-black": 11014,
          "medium-black": 11016,
          "large-black": 11018,
          "small-oak": 27777,
          "medium-oak": 27778,
          "large-oak": 27779,
          "extra-large-no-frame": 53644,
          "small-white": 53645,
          "medium-white": 53646,
          "large-white": 53647
        }
      },
      "acryl": {
        "productId": 46947,
        "variations": { "xs": 46948, "small": 46949, "medium": 57102 }
      },
      "aluminium": {
        "productId": 46943,
        "variations": { "xs": 46944, "small": 46945, "medium": 46946 }
      },
      "tegel": { "productId": 66571, "variations": {} }
    }
  },
  "corporateGift": {
    "products": {
      "paper": {
        "productId": 5825,
        "variations": {
          "small-no-frame": 11053,
          "medium-no-frame": 11055,
          "large-no-frame": 11059,
          "small-black": 11049,
          "medium-black": 11052,
          "large-black": 11057,
          "small-oak": 27783,
          "medium-oak": 27784,
          "large-oak": 27785,
          "extra-large-no-frame": 53648,
          "small-white": 53649,
          "medium-white": 53650,
          "large-white": 53651
        }
      },
      "acryl": {
        "productId": 46940,
        "variations": { "xs": 46941, "small": 46942, "medium": 57103 }
      },
      "aluminium": {
        "productId": 46936,
        "variations": { "xs": 46937, "small": 46938, "medium": 46939 }
      },
      "tegel": { "productId": 66571, "variations": {} }
    }
  },
  "specialLocation": {
    "products": {
      "paper": {
        "productId": 4439,
        "variations": {
          "small-no-frame": 11384,
          "medium-no-frame": 11390,
          "large-no-frame": 11399,
          "small-black": 11386,
          "medium-black": 11394,
          "large-black": 11403,
          "small-oak": 27789,
          "medium-oak": 27790,
          "large-oak": 27791,
          "extra-large-no-frame": 53652,
          "small-white": 53653,
          "medium-white": 53654,
          "large-white": 53655
        }
      },
      "acryl": {
        "productId": 46932,
        "variations": { "xs": 46933, "small": 46934, "medium": 57104 }
      },
      "aluminium": {
        "productId": 46928,
        "variations": { "xs": 46929, "small": 46930, "medium": 46931 }
      },
      "tegel": { "productId": 66571, "variations": {} }
    }
  },
  "sportsmap": {
    "products": {
      "paper": {
        "productId": 4199,
        "variations": {
          "small-no-frame": 4200,
          "medium-no-frame": 4202,
          "large-no-frame": 4204,
          "small-black": 4201,
          "medium-black": 4203,
          "large-black": 4657,
          "small-oak": 27808,
          "medium-oak": 27809,
          "large-oak": 27810,
          "extra-large-no-frame": 53464,
          "small-white": 53460,
          "medium-white": 53461,
          "large-white": 53462
        }
      },
      "acryl": {
        "productId": 52992,
        "variations": { "xs": 52993, "small": 52994, "medium": 53466 }
      },
      "aluminium": {
        "productId": 52996,
        "variations": { "xs": 52997, "small": 52998, "medium": 52999 }
      },
      "tegel": { "productId": 67051, "variations": {} }
    }
  },
  "lovemap": {
    "products": {
      "paper": {
        "productId": 3580,
        "variations": {
          "small-no-frame": 3581,
          "medium-no-frame": 3582,
          "large-no-frame": 3583,
          "small-black": 3637,
          "medium-black": 3638,
          "large-black": 4658,
          "small-oak": 27805,
          "medium-oak": 27806,
          "large-oak": 27807
        }
      }
    }
  },
  "date": {
    "products": {
      "paper": {
        "productId": 11435,
        "variations": {
          "small-no-frame": 11437,
          "medium-no-frame": 11439,
          "large-no-frame": 11441,
          "extra-large-no-frame": 65480,
          "small-black": 11438,
          "medium-black": 11440,
          "large-black": 11436,
          "small-oak": 27802,
          "medium-oak": 27803,
          "large-oak": 27804,
          "small-white": 65481,
          "medium-white": 65482,
          "large-white": 65483
        }
      },
      "acryl": {
        "productId": 65484,
        "variations": { "xs": 65486, "small": 65487, "medium": 65485 }
      },
      "aluminium": {
        "productId": 65490,
        "variations": { "xs": 65491, "small": 65492, "medium": 65493 }
      }
    }
  },
  "dictionary": {
    "products": {
      "paper": {
        "productId": 8901,
        "variations": {
          "small-no-frame": 8903,
          "medium-no-frame": 8905,
          "large-no-frame": 8907,
          "extra-large-no-frame": 65297,
          "small-black": 8904,
          "medium-black": 8906,
          "large-black": 8902,
          "small-oak": 27811,
          "medium-oak": 27812,
          "large-oak": 27813,
          "small-white": 65298,
          "medium-white": 65299,
          "large-white": 65300
        }
      },
      "acryl": {
        "productId": 65301,
        "variations": { "xs": 65303, "small": 65304, "medium": 65302 }
      },
      "aluminium": {
        "productId": 65311,
        "variations": { "xs": 65312, "small": 65313, "medium": 65314 }
      },
      "tegel": { "productId": 67324, "variations": { "small": 67324 } }
    }
  },
  "realtor": {
    "products": {
      "paper": {
        "productId": 5753,
        "variations": {
          "small-black": 6167,
          "medium-black": 5883,
          "large-black": 5882,
          "small-oak": 27797,
          "medium-oak": 27799,
          "large-oak": 27801,
          "small-white": 53656,
          "medium-white": 53657,
          "large-white": 53658
        }
      }
    }
  },
  "mothersDay": {
    "products": {
      "paper": {
        "productId": 4500,
        "variations": {
          "small-no-frame": 13689,
          "medium-no-frame": 13691,
          "large-no-frame": 13693,
          "small-black": 13690,
          "medium-black": 13692,
          "large-black": 13694,
          "small-oak": 28858,
          "medium-oak": 28859,
          "large-oak": 28860
        }
      },
      "heart": {
        "productId": 4494,
        "variations": {
          "small-no-frame": 4495,
          "medium-no-frame": 4497,
          "large-no-frame": 4499,
          "small-black": 4496,
          "medium-black": 4498,
          "large-black": 4661,
          "small-oak": 28838,
          "medium-oak": 28839,
          "large-oak": 28840
        }
      }
    }
  },
  "fathersDay": {
    "products": {
      "paper": {
        "productId": 4213,
        "variations": {
          "small-no-frame": 32330,
          "medium-no-frame": 32333,
          "large-no-frame": 32336,
          "extra-large-no-frame": 53850,
          "small-black": 32331,
          "medium-black": 32334,
          "large-black": 32337,
          "small-oak": 32332,
          "medium-oak": 32335,
          "large-oak": 32338,
          "small-white": 53851,
          "medium-white": 53852,
          "large-white": 53853
        }
      },
      "acryl": {
        "productId": 53854,
        "variations": { "xs": 53855, "small": 53856, "medium": 57105 }
      },
      "aluminium": {
        "productId": 53858,
        "variations": { "xs": 53859, "small": 53860, "medium": 53861 }
      }
    }
  },
  "hyrox": {
    "products": {
      "paper": {
        "productId": 49343,
        "variations": {
          "small-no-frame": 49344,
          "medium-no-frame": 49346,
          "large-no-frame": 49348,
          "extra-large-no-frame": 53533,
          "small-black": 49345,
          "medium-black": 49347,
          "large-black": 49349,
          "small-oak": 49350,
          "medium-oak": 49351,
          "large-oak": 49352,
          "small-white": 53534,
          "medium-white": 53535,
          "large-white": 53536
        }
      },
      "acryl": {
        "productId": 49360,
        "variations": { "xs": 49361, "small": 49362, "medium": 57109 }
      },
      "aluminium": {
        "productId": 49353,
        "variations": { "xs": 49354, "small": 49355, "medium": 49356 }
      }
    }
  },
  "psalm": {
    "products": {
      "paper": {
        "productId": 40142,
        "variations": {
          "small-no-frame": 40147,
          "medium-no-frame": 40149,
          "large-no-frame": 40151,
          "extra-large-no-frame": 65754,
          "small-black": 40148,
          "medium-black": 40150,
          "large-black": 40146,
          "small-oak": 40143,
          "medium-oak": 40144,
          "large-oak": 40145,
          "small-white": 65755,
          "medium-white": 65756,
          "large-white": 65757
        }
      },
      "acryl": {
        "productId": 65760,
        "variations": { "xs": 65762, "small": 65763, "medium": 65761 }
      },
      "aluminium": {
        "productId": 65767,
        "variations": { "xs": 65768, "small": 65769, "medium": 65770 }
      }
    }
  },
  "starmap": {
    "products": {
      "paper": {
        "productId": 45920,
        "variations": {
          "small-no-frame": 45925,
          "medium-no-frame": 45927,
          "large-no-frame": 45929,
          "extra-large-no-frame": 53630,
          "small-black": 45926,
          "medium-black": 45928,
          "large-black": 45924,
          "small-oak": 45921,
          "medium-oak": 45922,
          "large-oak": 45923,
          "small-white": 53631,
          "medium-white": 53632,
          "large-white": 53633
        }
      },
      "acryl": {
        "productId": 45936,
        "variations": { "xs": 45938, "small": 45941, "medium": 57107 }
      },
      "aluminium": {
        "productId": 45943,
        "variations": { "xs": 45944, "small": 45945, "medium": 45946 }
      }
    }
  },
  "photoGift": {
    "products": {
      "paper": {
        "productId": 57144,
        "variations": {
          "small-no-frame": 57146,
          "medium-no-frame": 57150,
          "large-no-frame": 57154,
          "extra-large-no-frame": 57158,
          "small-black": 57147,
          "medium-black": 57151,
          "large-black": 57155,
          "small-oak": 57148,
          "medium-oak": 57152,
          "large-oak": 57156,
          "small-white": 57149,
          "medium-white": 57153,
          "large-white": 57157
        }
      },
      "acryl": {
        "productId": 57164,
        "variations": { "xs": 57166, "small": 57167, "medium": 57165 }
      },
      "aluminium": {
        "productId": 57169,
        "variations": { "xs": 57170, "small": 57171, "medium": 57172 }
      },
      "tegel": { "productId": 67131, "variations": {} }
    }
  },
  "fourDaysMarches": {
    "products": {
      "paper": {
        "productId": 4199,
        "variations": {
          "small-no-frame": 4200,
          "medium-no-frame": 4202,
          "large-no-frame": 4204,
          "extra-large-no-frame": 53464,
          "small-black": 4201,
          "medium-black": 4203,
          "large-black": 4657,
          "small-oak": 27808,
          "medium-oak": 27809,
          "large-oak": 27810,
          "small-white": 53460,
          "medium-white": 53461,
          "large-white": 53462
        }
      },
      "acryl": {
        "productId": 52992,
        "variations": { "xs": 52993, "small": 52994, "medium": 53466 }
      },
      "aluminium": {
        "productId": 52996,
        "variations": { "xs": 52997, "small": 52998, "medium": 52999 }
      },
      "tegel": { "productId": 67051, "variations": {} }
    }
  },
  "songtext": {
    "products": {
      "paper": {
        "productId": 27942,
        "variations": {
          "small-no-frame": 27947,
          "medium-no-frame": 27949,
          "large-no-frame": 27951,
          "extra-large-no-frame": 53624,
          "small-black": 27948,
          "medium-black": 27950,
          "large-black": 27946,
          "small-oak": 27943,
          "medium-oak": 27944,
          "large-oak": 27945,
          "small-white": 53625,
          "medium-white": 53627,
          "large-white": 53628
        }
      },
      "acryl": {
        "productId": 42761,
        "variations": { "xs": 42763, "small": 42766, "medium": 57106 }
      },
      "aluminium": {
        "productId": 44527,
        "variations": { "xs": 44528, "small": 44531, "medium": 44532 }
      }
    }
  }
}
